/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PaginatedLogEntryList,
    PaginatedLogEntryListFromJSON,
    PaginatedLogEntryListToJSON,
} from '../models';

export interface ListAuditlogRequest {
    dateFrom?: Date;
    dateTo?: Date;
    deal?: number;
    dealState?: Array<ListAuditlogDealStateEnum>;
    objectId?: number;
    objectType?: ListAuditlogObjectTypeEnum;
    ordering?: string;
    page?: number;
    pageSize?: number;
    person?: number;
    search?: string;
    systemChanges?: boolean;
}

/**
 * AuditlogApi - interface
 * 
 * @export
 * @interface AuditlogApiInterface
 */
export interface AuditlogApiInterface {
    /**
     * A simple ViewSet for viewing Auditlog.
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {number} [deal] 
     * @param {Array<'ACTIVE' | 'CLOSED' | 'CLOSED_APPLICATION' | 'CONTRACT_COMPLETION' | 'CONTRACT_SIGN' | 'FILED_FOR_INSOLVENCY' | 'NEW_APPLICATION'>} [dealState] 
     * @param {number} [objectId] 
     * @param {'address' | 'amldraft' | 'applicationform' | 'applicationformlead' | 'bankaccount' | 'bankingcredentials' | 'basedeal' | 'baseperson' | 'blockageagreementbreach' | 'blockageagreementobligation' | 'borrowing' | 'breach' | 'cadastralarea' | 'cadastrallocation' | 'cadastralrights' | 'cadastraltitledeed' | 'cadastralworkplace' | 'calldata' | 'case' | 'casefinding' | 'claims' | 'claimsgroup' | 'claimsgrouplease' | 'claimsgroupleaseback' | 'claimssettings' | 'claimsstate' | 'claimsstatement' | 'claimsum' | 'cncbbasedeal' | 'cncbbatch' | 'cncbinstitution' | 'cncbpersonconnection' | 'cncbpersonreport' | 'cncbrepaymentoperation' | 'company' | 'consent' | 'consumerloan' | 'contact' | 'contenttype' | 'cpdraft' | 'dealbreach' | 'dealrealtygroup' | 'dealstate' | 'debt' | 'distraint' | 'draft' | 'dynamicclaim' | 'esipdraft' | 'event' | 'form' | 'group' | 'groupestimation' | 'grouprealty' | 'idmevaluation' | 'immovable' | 'incomesandexpenses' | 'incometaxevidencebreach' | 'incometaxevidenceobligation' | 'installment' | 'investmentloan' | 'isirinsolvencyscreening' | 'ispisceescreening' | 'ispisobchrscreening' | 'ispisosobacuzkscreening' | 'ispisrzpscreening' | 'label' | 'lead' | 'leadcase' | 'leadsorlead' | 'lease' | 'leasing' | 'legalentity' | 'logentry' | 'married' | 'merkpersonrelationsscreening' | 'mvcrscreening' | 'nonpayingbreach' | 'notarialdeedbreach' | 'notarialdeedobligation' | 'note' | 'notice' | 'noticegroup' | 'nzodraft' | 'nzoudraft' | 'obligation' | 'otherdeal' | 'otherdocumentsbreach' | 'otherdocumentsobligation' | 'participant' | 'payment' | 'permission' | 'physicalentity' | 'pipedriveperson' | 'pipedrivepersonadded' | 'pipedrivepersondeleted' | 'pipedrivepersonmerged' | 'pipedrivepersonupdated' | 'pipedrivezobinotes' | 'pmedraft' | 'pmukudraft' | 'ppvdraft' | 'prudraft' | 'purchasedproperty' | 'purpose' | 'purposedrawing' | 'realty' | 'realtylegalrelations' | 'reporate' | 'report' | 'requisition' | 'right' | 'rpdraft' | 'rsdraft' | 'sale' | 'saleandleaseback' | 'screening' | 'session' | 'sevenfinancelead' | 'smdraft' | 'snapshot' | 'sokordiatransactionscoringscreening' | 'spudraft' | 'ssodraft' | 'ssudraft' | 'staticclaim' | 'store' | 'szdraft' | 'szoudraft' | 'thirdpartyevidencebreach' | 'thirdpartyevidenceobligation' | 'token' | 'tokenproxy' | 'user' | 'useradditionaldata' | 'vindraft' | 'volsorlead' | 'zobibuilding' | 'zobicadastralright' | 'zobidata' | 'zobidistraintcase' | 'zobiosobacuzkscreening' | 'zobiowner' | 'zobiownerrightslimitations' | 'zobiparcel' | 'zobititledeed' | 'zobiunit'} [objectType] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {number} [person] 
     * @param {string} [search] A search term.
     * @param {boolean} [systemChanges] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditlogApiInterface
     */
    listAuditlogRaw(requestParameters: ListAuditlogRequest): Promise<runtime.ApiResponse<PaginatedLogEntryList>>;

    /**
     * A simple ViewSet for viewing Auditlog.
     */
    listAuditlog(requestParameters: ListAuditlogRequest): Promise<PaginatedLogEntryList>;

}

/**
 * 
 */
export class AuditlogApi extends runtime.BaseAPI implements AuditlogApiInterface {

    /**
     * A simple ViewSet for viewing Auditlog.
     */
    async listAuditlogRaw(requestParameters: ListAuditlogRequest): Promise<runtime.ApiResponse<PaginatedLogEntryList>> {
        const queryParameters: any = {};

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['date_from'] = (requestParameters.dateFrom as any).toISOString().substr(0,10);
        }

        if (requestParameters.dateTo !== undefined) {
            queryParameters['date_to'] = (requestParameters.dateTo as any).toISOString().substr(0,10);
        }

        if (requestParameters.deal !== undefined) {
            queryParameters['deal'] = requestParameters.deal;
        }

        if (requestParameters.dealState) {
            queryParameters['deal_state'] = requestParameters.dealState;
        }

        if (requestParameters.objectId !== undefined) {
            queryParameters['object_id'] = requestParameters.objectId;
        }

        if (requestParameters.objectType !== undefined) {
            queryParameters['object_type'] = requestParameters.objectType;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page-size'] = requestParameters.pageSize;
        }

        if (requestParameters.person !== undefined) {
            queryParameters['person'] = requestParameters.person;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.systemChanges !== undefined) {
            queryParameters['system_changes'] = requestParameters.systemChanges;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/auditlog/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedLogEntryListFromJSON(jsonValue));
    }

    /**
     * A simple ViewSet for viewing Auditlog.
     */
    async listAuditlog(requestParameters: ListAuditlogRequest): Promise<PaginatedLogEntryList> {
        const response = await this.listAuditlogRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListAuditlogDealStateEnum {
    Active = 'ACTIVE',
    Closed = 'CLOSED',
    ClosedApplication = 'CLOSED_APPLICATION',
    ContractCompletion = 'CONTRACT_COMPLETION',
    ContractSign = 'CONTRACT_SIGN',
    FiledForInsolvency = 'FILED_FOR_INSOLVENCY',
    NewApplication = 'NEW_APPLICATION'
}
/**
    * @export
    * @enum {string}
    */
export enum ListAuditlogObjectTypeEnum {
    Address = 'address',
    Amldraft = 'amldraft',
    Applicationform = 'applicationform',
    Applicationformlead = 'applicationformlead',
    Bankaccount = 'bankaccount',
    Bankingcredentials = 'bankingcredentials',
    Basedeal = 'basedeal',
    Baseperson = 'baseperson',
    Blockageagreementbreach = 'blockageagreementbreach',
    Blockageagreementobligation = 'blockageagreementobligation',
    Borrowing = 'borrowing',
    Breach = 'breach',
    Cadastralarea = 'cadastralarea',
    Cadastrallocation = 'cadastrallocation',
    Cadastralrights = 'cadastralrights',
    Cadastraltitledeed = 'cadastraltitledeed',
    Cadastralworkplace = 'cadastralworkplace',
    Calldata = 'calldata',
    Case = 'case',
    Casefinding = 'casefinding',
    Claims = 'claims',
    Claimsgroup = 'claimsgroup',
    Claimsgrouplease = 'claimsgrouplease',
    Claimsgroupleaseback = 'claimsgroupleaseback',
    Claimssettings = 'claimssettings',
    Claimsstate = 'claimsstate',
    Claimsstatement = 'claimsstatement',
    Claimsum = 'claimsum',
    Cncbbasedeal = 'cncbbasedeal',
    Cncbbatch = 'cncbbatch',
    Cncbinstitution = 'cncbinstitution',
    Cncbpersonconnection = 'cncbpersonconnection',
    Cncbpersonreport = 'cncbpersonreport',
    Cncbrepaymentoperation = 'cncbrepaymentoperation',
    Company = 'company',
    Consent = 'consent',
    Consumerloan = 'consumerloan',
    Contact = 'contact',
    Contenttype = 'contenttype',
    Cpdraft = 'cpdraft',
    Dealbreach = 'dealbreach',
    Dealrealtygroup = 'dealrealtygroup',
    Dealstate = 'dealstate',
    Debt = 'debt',
    Distraint = 'distraint',
    Draft = 'draft',
    Dynamicclaim = 'dynamicclaim',
    Esipdraft = 'esipdraft',
    Event = 'event',
    Form = 'form',
    Group = 'group',
    Groupestimation = 'groupestimation',
    Grouprealty = 'grouprealty',
    Idmevaluation = 'idmevaluation',
    Immovable = 'immovable',
    Incomesandexpenses = 'incomesandexpenses',
    Incometaxevidencebreach = 'incometaxevidencebreach',
    Incometaxevidenceobligation = 'incometaxevidenceobligation',
    Installment = 'installment',
    Investmentloan = 'investmentloan',
    Isirinsolvencyscreening = 'isirinsolvencyscreening',
    Ispisceescreening = 'ispisceescreening',
    Ispisobchrscreening = 'ispisobchrscreening',
    Ispisosobacuzkscreening = 'ispisosobacuzkscreening',
    Ispisrzpscreening = 'ispisrzpscreening',
    Label = 'label',
    Lead = 'lead',
    Leadcase = 'leadcase',
    Leadsorlead = 'leadsorlead',
    Lease = 'lease',
    Leasing = 'leasing',
    Legalentity = 'legalentity',
    Logentry = 'logentry',
    Married = 'married',
    Merkpersonrelationsscreening = 'merkpersonrelationsscreening',
    Mvcrscreening = 'mvcrscreening',
    Nonpayingbreach = 'nonpayingbreach',
    Notarialdeedbreach = 'notarialdeedbreach',
    Notarialdeedobligation = 'notarialdeedobligation',
    Note = 'note',
    Notice = 'notice',
    Noticegroup = 'noticegroup',
    Nzodraft = 'nzodraft',
    Nzoudraft = 'nzoudraft',
    Obligation = 'obligation',
    Otherdeal = 'otherdeal',
    Otherdocumentsbreach = 'otherdocumentsbreach',
    Otherdocumentsobligation = 'otherdocumentsobligation',
    Participant = 'participant',
    Payment = 'payment',
    Permission = 'permission',
    Physicalentity = 'physicalentity',
    Pipedriveperson = 'pipedriveperson',
    Pipedrivepersonadded = 'pipedrivepersonadded',
    Pipedrivepersondeleted = 'pipedrivepersondeleted',
    Pipedrivepersonmerged = 'pipedrivepersonmerged',
    Pipedrivepersonupdated = 'pipedrivepersonupdated',
    Pipedrivezobinotes = 'pipedrivezobinotes',
    Pmedraft = 'pmedraft',
    Pmukudraft = 'pmukudraft',
    Ppvdraft = 'ppvdraft',
    Prudraft = 'prudraft',
    Purchasedproperty = 'purchasedproperty',
    Purpose = 'purpose',
    Purposedrawing = 'purposedrawing',
    Realty = 'realty',
    Realtylegalrelations = 'realtylegalrelations',
    Reporate = 'reporate',
    Report = 'report',
    Requisition = 'requisition',
    Right = 'right',
    Rpdraft = 'rpdraft',
    Rsdraft = 'rsdraft',
    Sale = 'sale',
    Saleandleaseback = 'saleandleaseback',
    Screening = 'screening',
    Session = 'session',
    Sevenfinancelead = 'sevenfinancelead',
    Smdraft = 'smdraft',
    Snapshot = 'snapshot',
    Sokordiatransactionscoringscreening = 'sokordiatransactionscoringscreening',
    Spudraft = 'spudraft',
    Ssodraft = 'ssodraft',
    Ssudraft = 'ssudraft',
    Staticclaim = 'staticclaim',
    Store = 'store',
    Szdraft = 'szdraft',
    Szoudraft = 'szoudraft',
    Thirdpartyevidencebreach = 'thirdpartyevidencebreach',
    Thirdpartyevidenceobligation = 'thirdpartyevidenceobligation',
    Token = 'token',
    Tokenproxy = 'tokenproxy',
    User = 'user',
    Useradditionaldata = 'useradditionaldata',
    Vindraft = 'vindraft',
    Volsorlead = 'volsorlead',
    Zobibuilding = 'zobibuilding',
    Zobicadastralright = 'zobicadastralright',
    Zobidata = 'zobidata',
    Zobidistraintcase = 'zobidistraintcase',
    Zobiosobacuzkscreening = 'zobiosobacuzkscreening',
    Zobiowner = 'zobiowner',
    Zobiownerrightslimitations = 'zobiownerrightslimitations',
    Zobiparcel = 'zobiparcel',
    Zobititledeed = 'zobititledeed',
    Zobiunit = 'zobiunit'
}
